import { createReducer } from "../reducer_utils";

const initialState = {
  data: null,
  network_activity: []
};

const getFetchingMessage = action => {
  let { resourceType, domain, linkType, url } = action;
  const messages = {
    broken_links: `fetch_broken_links_${domain}_${linkType}`,
    affected_pages: `fetch_affected_pages_${domain}_${url}`
  };
  return messages[resourceType] || "";
};

const addNetworkActivityMessage = (networkActivity, action) => [...networkActivity, getFetchingMessage(action)];

const removeNetworkActivityMessage = (networkActivity, msgType, action) => {
  return networkActivity.filter(msg => msg !== getFetchingMessage(msgType, action));
};

const fetchResourceInProgress = (state, action) => ({
  ...state,
  network_activity: addNetworkActivityMessage(state.network_activity, action)
});

const fetchResourceFailed = (state, action) => ({
  ...state,
  network_activity: removeNetworkActivityMessage(state.network_activity, action)
});

const fetchBrokenLinksSuccessful = (state, action) => {
  const domainData = state["data"] && state["data"][action.domain];

  return {
    ...state,
    network_activity: removeNetworkActivityMessage(state.network_activity, action),
    data: {
      ...state["data"],
      [action.domain]: {
        ...domainData,
        [action.linkType]: updateBrokenLinksForDomain(state, action)
      }
    }
  };
};

const updateBrokenLinksForDomain = (state, action) => {
  let brokenLinksForDomain;

  try {
    brokenLinksForDomain = state["data"][action.domain][action.linkType];
  } catch (e) {
    brokenLinksForDomain = {};
  }
  if (brokenLinksForDomain && Object.keys(brokenLinksForDomain).length) {
    return {
      ...brokenLinksForDomain,
      last_url_hash: action["response"]["last_url_hash"],
      links: [...brokenLinksForDomain["links"], ...action["response"]["broken_links"]]
    };
  }
  return {
    last_url_hash: action["response"]["last_url_hash"],
    links: action["response"]["broken_links"]
  };
};

const fetchAffectedPagesSuccessful = (state, action) => {
  return {
    ...state,
    network_activity: removeNetworkActivityMessage(state.network_activity, action),
    data: {
      ...state["data"],
      [action.domain]: {
        ...state["data"][action.domain],
        affected_pages: updateAffectedPagesForDomain(state, action)
      }
    }
  };
};

const updateAffectedPagesForDomain = (state, action) => {
  let affectedPagesForDomain;

  try {
    affectedPagesForDomain = state["data"][action.domain]["affected_pages"];
  } catch (e) {
    affectedPagesForDomain = {};
  }

  if (affectedPagesForDomain && Object.keys(affectedPagesForDomain).length) {
    return {
      ...affectedPagesForDomain,
      [action.url]: updateAffectedPagesForUrl(state, action)
    };
  }
  return {
    [action["url"]]: {
      last_uat: action["response"]["last_uat"],
      pages: action["response"]["pages"]
    }
  };
};

const updateAffectedPagesForUrl = (state, action) => {
  let affectedPagesForUrl;

  try {
    affectedPagesForUrl = state["data"][action.domain]["affected_pages"][action.url];
  } catch (e) {
    affectedPagesForUrl = {};
  }

  if (affectedPagesForUrl && Object.keys(affectedPagesForUrl).length) {
    return {
      ...affectedPagesForUrl,
      last_uat: action["response"]["last_uat"],
      pages: [...affectedPagesForUrl["pages"], ...action["response"]["pages"]]
    };
  }
  return {
    last_uat: action["response"]["last_uat"],
    pages: action["response"]["pages"]
  };
};

const resetState = (state, _) => ({ ...state, ...initialState });

const resetAffectedPages = (state, action) => {
  let affectedPages = state["data"][action.domain]["affected_pages"];
  let { [action.url]: discardedValue, ...updatedAffectedPages } = affectedPages;
  return {
    ...state,
    data: {
      ...state["data"],
      [action.domain]: {
        ...state["data"][action.domain],
        affected_pages: updatedAffectedPages
      }
    }
  };
};

const brokenLinksReducer = createReducer(initialState, {
  FETCH_AFFECTED_PAGES_IN_PROGRESS: fetchResourceInProgress,
  FETCH_AFFECTED_PAGES_SUCCESSFUL: fetchAffectedPagesSuccessful,
  FETCH_AFFECTED_PAGES_FAILED: fetchResourceFailed,

  FETCH_BROKEN_LINKS_IN_PROGRESS: fetchResourceInProgress,
  FETCH_BROKEN_LINKS_SUCCESSFUL: fetchBrokenLinksSuccessful,
  FETCH_BROKEN_LINKS_FAILED: fetchResourceFailed,

  RESET_BROKEN_LINKS: resetState,
  RESET_AFFECTED_PAGES: resetAffectedPages,
  LOGOUT: resetState
});

export default brokenLinksReducer;
